import React, { useEffect, useState } from "react";
import { Navbar, Nav as BootstrapNav, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

function Nav() {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".navbar")) {
        setExpanded(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  return (
    <Navbar bg="dark" variant="dark" expand="lg" dir="rtl" expanded={expanded}>
      <Container>
        <Navbar.Brand as={NavLink} to="/" className="text-info fs-2">
          موقعي
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <BootstrapNav className="m-auto gap-3 fs-4 text-center">
            <NavLink
              onClick={() => setExpanded(false)}
              className="text-decoration-none"
              to="/"
            >
              نبذه عني
            </NavLink>
            <NavLink
              onClick={() => setExpanded(false)}
              className="text-decoration-none"
              to="/amthal"
            >
              امثال عربيه
            </NavLink>
            <NavLink
              onClick={() => setExpanded(false)}
              className="text-decoration-none"
              to="/gallery"
            >
              خلفيات منوعة
            </NavLink>
          </BootstrapNav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Nav;
